export default "__VITE_ASSET__Df33b4sk__"